/* @flow */
import { Record } from '../transit';

const User = Record({
  email: '',
  name: '',
  token: '',
  locked: false,
  authorities: [],
  pinSet: false,
  organizationId: '',
  organizationLanguage: '',
  organizationCurrency: '',
  userId: '',
  isConfigured: false,
  isAdmin: false
}, 'user');

export default User;



// WEBPACK FOOTER //
// ./src/common/users/user.js